angular.module('elfium').directive('dashboardActivityList', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'dashboardActivityListController',
        templateUrl: elfiumUrlService.getTemplateUrl('dashboard', 'dashboardActivityList')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardActivityList.ts